export const COLOR_PALETTE = {
  BLACK_0: '#000000',
  BLACK_1: '#0000007f',
  BLACK_2: '#000000cc',
  BLACK_3: '#0000004c',
  BLACK_4: '#00000033',
  BLACK_5: '#0000001e',
  BLACK_6: '#00000014',
  BLACK_7: '#0000000f',
  BLACK_8: '#111111',

  BLUE_0: '#007cb0',
  BLUE_1: '#a0dcff',
  BLUE_2: '#d9ecf3',
  BLUE_3: '#00a3e0',
  BLUE_4: '#0076a8',
  BLUE_5: '#005587',
  BLUE_6: '#106ebe',
  BLUE_7: '#edf7fa',
  BLUE_8: '#5b5fc7',
  BLUE_9: '#0072B1',
  BLUE_10: '#0073E6 ',
  BLUE_11: '#00A4E4  ',

  COOL_GRAY_0: '#f8f9fa',
  COOL_GRAY_1: '#e6e6e6',
  COOL_GRAY_2: '#d0d0ce',
  COOL_GRAY_3: '#f5f5f5',
  COOL_GRAY_4: '#bbbcbc',
  COOL_GRAY_5: '#f0f0f0',
  COOL_GRAY_6: '#a7a8aa',
  COOL_GRAY_7: '#ebebeb',
  COOL_GRAY_8: '#d0d0ce19',
  COOL_GRAY_9: '#d0d0d07f',
  COOL_GRAY_10: '#63666a',
  COOL_GRAY_11: '#53565a',
  COOL_GRAY_12: '#75787b40',
  COOL_GRAY_13: '#2e2e2e',
  COOL_GRAY_14: '#f6f6f6',
  COOL_GRAY_15: '#e5e5e5',
  COOL_GRAY_16: '#f9f9f9',
  COOL_GRAY_17: '#f4f4f4f4',
  COOL_GRAY_18: '#4B4B4D',
  COOL_GRAY_19: '#D9D9D6',
  COOL_GRAY_20: '#EAF5EA',

  GREEN_0: '#26890d',
  GREEN_1: '#20730b',
  GREEN_2: '#1d680a',
  GREEN_3: '#0d8390',
  GREEN_4: '#004f59',
  GREEN_5: '#ddefe8',
  GREEN_6: '#26890d0c',
  GREEN_7: '#26890D1E',
  GREEN_8: '#046A38',
  GREEN_9: '#dfeddb',

  YELLOW_0: '#ffEb3b',
  ORANGE_0: '#ed8b00',

  RED_0: '#da291c',
  RED_1: '#bf3431',
  RED_2: '#71150f',
  RED_3: '#bf34310c',
  RED_4: '#fbe5e4',

  TRANSPARENT: 'transparent',

  WHITE_0: '#ffffff',
  WHITE_1: '#ffffffe0',
  WHITE_2: '#ffffff0f',
} as const;
